import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest } from "../Common/request";

export type RegistrationRequest = {
    honeypot: string;
    email: string;
    password: string;
    requiredConsents: boolean;
    backUrl?: string;
};

export type RegistrationResponse = {
    redirectUrl: string;
};

export default {
    createUser(data: RegistrationRequest): Promise<RegistrationResponse> {
        return usePromisedRequest<RegistrationResponse>({
            url: `/api/registration`,
            method: "post",
            json: data,
        }).then(resolveWithBody());
    },
    resendActivationEmail(accountRegistrationId: string) {
        return usePromisedRequest({
            url: `/api/registration/${accountRegistrationId}/resend-activation-email`,
            method: "post",
            json: true,
        }).then(resolveNoContent());
    },
    changeEmail(accountRegistrationId: string, newEmail: string) {
        return usePromisedRequest({
            url: `/api/registration/${accountRegistrationId}/change-email`,
            method: "post",
            json: { email: newEmail },
        }).then(resolveNoContent());
    },
};
